/*
DEFINE CLIENT APP ROUTS 
*/
import React from 'react'
import { Route ,Switch } from 'react-router-dom'


// pages
import Home from '../Pages/Home/Home';
import SpacielDeals from '../Pages/SpacielDeals/SpacielDeals';
import LiveShows from '../Pages/LiveShows/LiveShows';
import ExporeTelAvivAndJerusalem from '../Pages/ExporeTelAvivAndJerusalem/ExporeTelAvivAndJerusalem';
import TermsOfUse from '../Pages/TermsOfUse/TermsOfUse';
import ThingsToDo from '../Pages/ThingsToDo/ThingsToDo';
import WhereToGo from '../Pages/WhereToGo/WhereToGo';
import FAQ from '../Pages/FAQ/FAQ';
import TelAvivPage from '../Pages/TelAvivPage/TelAvivPage';
import JerusalemPage from '../Pages/JerusalemPage/JerusalemPage';
import CulinaryPage from '../Pages/CulinaryPage/CulinaryPage';
import DeadSeaPage from '../Pages/DeadSeaPage/DeadSeaPage';
import TouristInfoPage from '../Pages/TouristInfo/TouristInfoPage';
import EilatNegevPage from '../Pages/EilatNegevPage/EilatNegevPage';
import NorthPage from '../Pages/NorthPage/NorthPage';
import CoronaVirusPage from '../Pages/CoronaVirusPage/CoronaVirus';
import CoronaVirusPageCZ from '../Pages/CoronaVirusPage/CoronaVirusCZ';
import CoronaVirusPageDK from '../Pages/CoronaVirusPage/CoronaVirusDK';
import CoronaVirusPageHU from '../Pages/CoronaVirusPage/CoronaVirusHU';
import CoronaVirusPageNL from '../Pages/CoronaVirusPage/CoronaVirusNL';
import CoronaVirusPageRO from '../Pages/CoronaVirusPage/CoronaVirusRO';
import CoronaVirusPageSE from '../Pages/CoronaVirusPage/CoronaVirusSE';

import SearchPage from '../Pages/SearchPage/SearchPage';
// Posts
import VideosPosts from '../Posts/Videos/Videos';
import ConcertsPosts from '../Posts/Concerts/Concerts';
import Posts from '../Posts/Posts/Posts';


// Gallery
import GalleryTA from '../Pages/Gallery/TA/GalleryTA';
import GalleryJA from '../Pages/Gallery/JA/GalleryJA';
export const Routes = () => (
	
	<Switch>
	    <Route  path="/Pages/TelAvivPage" component={TelAvivPage} />
	    <Route  path="/Pages/EilatNegevPage" component={EilatNegevPage} />
	    <Route  path="/Pages/NorthPage" component={NorthPage} />
	    <Route  path="/Pages/JerusalemPage" component={JerusalemPage} />
	    <Route  path="/Pages/CulinaryPage" component={CulinaryPage} />
	    <Route  path="/Pages/DeadSeaPage" component={DeadSeaPage} />
	    <Route  path="/Pages/TouristInfoPage" component={TouristInfoPage} />
	    <Route  path="/Pages/CoronaVirusPage" component={CoronaVirusPage} />
	    <Route  path="/Pages/CoronaVirusPageCZ" component={CoronaVirusPageCZ} />
	    <Route  path="/Pages/CoronaVirusPageDK" component={CoronaVirusPageDK} />
	    <Route  path="/Pages/CoronaVirusPageHU" component={CoronaVirusPageHU} />
	    <Route  path="/Pages/CoronaVirusPageNL" component={CoronaVirusPageNL} />
	    <Route  path="/Pages/CoronaVirusPageRO" component={CoronaVirusPageRO} />
	    <Route  path="/Pages/CoronaVirusPageSE" component={CoronaVirusPageSE} />
	    <Route  path="/Pages/SearchPage" component={SearchPage} />
		<Route  path="/Pages/FAQ" component={FAQ} />
		<Route  path="/Pages/thingsToDo" component={ThingsToDo} />
		<Route  path="/Pages/whereToGo" component={WhereToGo} />
		<Route  path="/Pages/bestDeals" component={SpacielDeals} />
		<Route  path="/Pages/Gallery/:galleryId" component={GalleryTA} />
		<Route  path="/Pages/Gallery/" component={GalleryTA} />
		<Route  path="/Pages/TermsOfUse" component={TermsOfUse} />
		<Route  path="/Pages/liveShows" component={LiveShows} />
		<Route  path="/Pages/Videos" component={ExporeTelAvivAndJerusalem} />
		<Route  path="/Posts/Videos/:ctgId/:vidId" component={VideosPosts} />
		<Route  path="/Posts/Concerts/:id" component={ConcertsPosts} />
		<Route  path="/Posts/:ctgId/:id" component={Posts} />
		<Route  path="/" component={Home} />
	</Switch>

);




// WEBPACK FOOTER //
// ./src/Routes/Routes.js